export const imageList = {
  logo: new URL("../assets/images/Logo.png", import.meta.url).href,
  avatar: new URL("../assets/images/Avatar.png", import.meta.url).href,
  euImage: new URL("../assets/images/eu-image.png", import.meta.url).href,
  samplePartner: new URL("../assets/images/sample-image.png", import.meta.url)
    .href,
  targetLogo: new URL("../assets/images/target.png", import.meta.url).href,
  noimage: new URL("../assets/images/user-avatar.jpg", import.meta.url).href,
  noOrgimage: new URL("../assets/images/org-avatar.jpg", import.meta.url).href,
  file: new URL("../assets/images/file.png", import.meta.url).href,
  zap: new URL("../assets/images/zap.svg", import.meta.url).href,
  checkIcon: new URL("../assets/images/checkIcon.svg", import.meta.url).href,
  helpIcon: new URL("../assets/images/help.png", import.meta.url).href,
  help: new URL("../assets/images/questionMark.svg", import.meta.url).href,
  rocket: new URL("../assets/images/rocket.png", import.meta.url).href,
  googleIcon: new URL("../assets/images/google-icon.jpg", import.meta.url).href,
  fbIcon: new URL("../assets/images/fb-icon.png", import.meta.url).href,
  linkedinIcon: new URL("../assets/images/linkedin-icon.png", import.meta.url)
    .href,
  dashboardIcon: new URL("../assets/images/dashboard.png", import.meta.url)
    .href,
  ideasNoContentBgIcon: new URL(
    "../assets/images/idea_noContent_bg.png",
    import.meta.url,
  ).href,
};
